import { WordTimeslot } from './speechText'

export const ENGINE_KIND = {
  CLIP: 'clip',
  WEB_SPEECH: 'web_speech',
} as const

export type EngineKind = typeof ENGINE_KIND[keyof typeof ENGINE_KIND]

export const CLIP_STATE = {
  MISSING: 'missing',
  PENDING: 'pending',
  STICKY: 'sticky',
  UNSUPPORTED: 'unsupported',
} as const

export type ClipState = typeof CLIP_STATE[keyof typeof CLIP_STATE]

export const ENGINE_REASON = {
  ...CLIP_STATE,
  ERROR: 'error',
  READY: 'ready',
  SLOW: 'slow',
  THROUGHPUT: 'throughput',
  TIMEOUT: 'timeout',
} as const

export type FetchWatcher = (url: string) => Promise<Response>

export const plainFetch: FetchWatcher = url => fetch(url)

export type EngineReason = typeof ENGINE_REASON[keyof typeof ENGINE_REASON]

export type WordSpan = [number, number]

export interface ClipPayload {
  sentenceEnds: number[];
  timeline: WordTimeslot[];
  url: string;
  words: WordSpan[];
}

export interface SpeakOptions {
  clip?: ClipPayload;
  lang?: string;
  onBoundary?: (charIndex: number) => void;
  onEnd?: () => void;
  onEngine?: (kind: EngineKind, reason: EngineReason) => void;
  onError?: (reason: string) => void;
  onInterrupted?: () => void;
  onStall?: () => void;
  onStart?: () => void;
  rate?: number;
  startCharIndex?: number;
}

export interface SpeechEngine {
  readonly kind: EngineKind;
  cancel(): void;
  isSupported(): boolean;
  pause(): boolean;
  resume(): boolean;
  seekToChar(charIndex: number): boolean;
  setRate(rate: number): boolean;
  speak(text: string, options: SpeakOptions): object | null;
}
